import React, {Component} from 'react';
import NavBar from '../components/navbar';
import ProjectCard from '../components/ProjectCard';
import {Typography, IconButton} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { Row, Col  } from 'react-bootstrap';
import MemberCard from '../components/MemberCard';
import TalentProfileModal from '../components/TalentProfileModal';

const talents = [{
  name:"ahmed",
  skills:['python','sql','data-engineering'],
  title:"Software Engineer",
  mail:'this@this.com',
  education:'German University in Cairo'
},
{
  name:"mohamed",
  title:"Software Engineer",
  skills:['python','sql','data-engineering'],
  mail:'this@this.com',
  education:'German University in Cairo'
},
{
  name:"samir",
  title:"Student",
  skills:['python','sql','data-engineering'],
  mail:"student@student.com",
  education:"uni in Cairo"
}
]
const project = {
  Desc:"this is the project discription",
  title:"this is the project title"
}
const useStyles= theme =>({
  root:{
    '& .MuiSvgIcon-root':{
      color:'#153BAB',
    },
  },
  title:{
    fontFamily:['Nunito'].join(','),
    color:'#153BAB',
    paddingBottom:'10px',
    marginLeft:'30px',


  },
  info:{
    paddingBottom:'30px',
    fontFamily:['Nunito'].join(','),
    fontWeight:400,
    marginLeft:'30px',
    maxWidth:'70%',
    color:'black'
  },
  iconBar:{
    display:'flex',
    flexDirection:'row',
    padding:'10px 10px',
  },
  arrowIcon:{
    flexGrow:1,
  },
  Horizontalcontainer:{
    display:'flex',
    flexDirection:"column",

  },
  sideContainer:{
    display:'flex',


  },
  verticalContainer:{
    display:'flex',
    flexDirection:"row",

  },

  TabProjects:{
    fontWeight: 'bold',
    color: '#000000' ,
    fontSize: '20px',
    textShadow: '0px 0px 0px #000000',
    boxShadow: '0px 0px 0px #FFFFFF' ,
    padding: '10px 10px',
    borderRadius: '0px',
    background: '#FFFFFF',
  },
  iconBtn:{
    '& .MuiSvgIcon-root':{
      color:'#153BAB',
    },
    marginRight:'10px',
    marginTop:'-10px'
  },
  icon:{
    height:'35px',
    width:'35px',


  },
  team:{
    fontWeight: 'bold',
    color: '#000000' ,
    fontSize: '20px',
    textShadow: '0px 0px 0px #000000',
    boxShadow: '0px 0px 0px #FFFFFF' ,
    padding: '10px 10px',
    borderRadius: '0px',
    background: '#FFFFFF',
    marginLeft:"110px"
  }

});

class BusinessProjects extends Component{
  constructor(props) {
    super(props)
  this.ModalShow = this.ModalShow.bind(this)
  this.state = {
    modalShow: false,
    index: 0
  };
}

ModalShow() {
  if(this.state.modalShow === true){
    this.setState({
      modalShow:false
    })  
  }
  else{
  this.setState({
    modalShow:true,
  })
}
}
  render (){
    const {classes} = this.props;
    return(
      <div className={classes.root}>
      <NavBar type='main'/>
      <div className={classes.verticalContainer}>
      <Row>
      <Col xs={6} md={6}>
      <div className={classes.Horizontalcontainer}>
        <center>
        <div className={classes.iconBar}>
        <IconButton className={classes.iconBtn}><ArrowBackIcon className={classes.icon}/></IconButton>
          <div className={classes.arrowIcon}>
          <a href="/" className={classes.TabProjects}>
            Project Details
          </a>
          </div>
        </div>
        </center>

        <div>
        <ProjectCard name={project.title}/>
          <br /><br />
    <Typography className={classes.title}><strong>{project.Desc}</strong></Typography>
          <Typography className={classes.info}><strong>{this.props.about}</strong></Typography>
          </div>
          <center>
          </center>
          <div style={{marginTop:'50px'}}>
          </div>
        </div>
      </Col>
      <Col xs={6} md={6}>
      <div>
      <div className={classes.Horizontalcontainer}>
        <div className={classes.iconBar}>
          <div className={classes.arrowIcon}>
          <a href="/" className={classes.team}>
            Team
          </a>
          </div>
        </div>

        {talents.map((talent, index) => (
          <div key={index}>
            <MemberCard talent={talent} ModalShow={this.ModalShow}></MemberCard>   
          </div>
        ))}
      </div>
      <div>
        {talents.map((talent, index) => (
          <div key={index}>
            <TalentProfileModal show={this.state.modalShow} onHide={this.ModalShow} talent={talent}/>  
          </div>
        ))}
      </div>
      </div>
            </Col>
      </Row>
      </div>
      </div>
    );
  }
}
export default withStyles(useStyles)(BusinessProjects);
